function flatten(obj) {
  const toReturn = {};

  for (const prop of Object.keys(obj)) {
    if (!obj.hasOwnProperty(prop)) continue;

    if (typeof obj[prop] === 'object') {
      const flatObject = flatten(obj[prop]);

      for (const innerProp of Object.keys(flatObject)) {
        if (!flatObject.hasOwnProperty(innerProp)) continue;

        toReturn[`${prop}.${innerProp}`] = flatObject[innerProp];
      }
    } else {
      toReturn[prop] = obj[prop];
    }
  }
  return toReturn;
}

function getBase64(file, callback) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function() {
    callback(reader.result);
  };
  reader.onerror = function(error) {
    console.error('Unable to read file', error);
  };
}

function getMagicNumber(blob, callback) {
  const reader = new FileReader();
  reader.onloadend = evt => {
    if (evt.target.readyState === FileReader.DONE) {
      const uint = new Uint8Array(evt.target.result);
      const bytes = [];
      uint.forEach(byte => {
        const packed = ('0' + (byte & 0xff).toString(16)).slice(-2);
        bytes.push(packed);
      });
      const hex = bytes.join('').toUpperCase();
      callback(hex);
    }
  };
  reader.readAsArrayBuffer(blob.slice(0, 4));
}

export { flatten, getBase64, getMagicNumber };
